import { createFormState } from "redux-freeform";
import { emailFormatValidators } from "../../../util/emailValidators";

const formConfig = {
  email: {
    validators: emailFormatValidators // 'required' validator is conditionally added based on `isRequired` prop
  }
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  formConfig
);
